import { getInternationalNumber } from './getInternationalNumber.js';

/**
 * The libphonenumber-js parser will error out and not return a valid PhoneNumber
 * object. However, we wish to provide a consistent API where we always return
 * a PhoneNumber object with some properties, especially to indicate an invalid
 * number. Therefore, this util creates a bare minimum object which reflects
 * the current input and some validity information.
 */
var getInvalidPhoneNumber = function getInvalidPhoneNumber(number, countryCode) {
  return {
    number: getInternationalNumber(number),
    countryCode: countryCode,
    isPossible: false,
    isValid: false
  };
};

export { getInvalidPhoneNumber };
